var codeblock_default = {
  "blockStyleSpacing": "Q7Qzl",
  "codeBlock": "K8sAR Q7Qzl",
  "renderedInTable": "FTshe"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
